import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const StrategicActions = () => {
  const actions = [
    { id: 1, label: "Consolidate Seat Licenses", impact: "High", savings: "$2.4k/mo", icon: "Tool" },
    { id: 2, label: "Sync CRM & Paid Media", impact: "Medium", lift: "+12% ROAS", icon: "RefreshCw" },
    { id: 3, label: "Deploy AI Email Bot", impact: "Critical", time: "-15h/wk", icon: "Cpu" }
  ];

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border border-slate-100 dark:border-slate-800 text-slate-900 dark:text-white">
      <div className="flex items-center justify-between mb-8">
        <div>
          <span className="text-brand-yellow text-[10px] uppercase font-bold tracking-[0.2em] block mb-1">AI-Driven Recommendations</span>
          <h3 className="text-2xl font-heading font-bold">Priority Actions</h3>
        </div>
        <div className="p-2 bg-brand-yellow/20 rounded-lg">
          <SafeIcon name="Zap" className="w-6 h-6 text-brand-yellow" />
        </div>
      </div>

      <div className="space-y-4">
        {actions.map((action, idx) => (
          <motion.div 
            key={action.id}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="flex items-center gap-4 p-4 rounded-xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 hover:border-brand-yellow/30 transition-all group cursor-pointer"
          >
            <div className="w-10 h-10 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-brand-yellow group-hover:bg-brand-yellow group-hover:text-brand-dark transition-all">
              <SafeIcon name={action.icon} className="w-5 h-5" />
            </div>
            <div className="flex-grow">
              <h4 className="text-sm font-bold mb-1">{action.label}</h4>
              <div className="flex items-center gap-3">
                <span className={`text-[9px] uppercase font-black px-2 py-0.5 rounded ${
                  action.impact === 'Critical' ? 'bg-brand-red/20 text-brand-red' : 
                  action.impact === 'High' ? 'bg-brand-yellow/20 text-brand-yellow' : 'bg-brand-cyan/20 text-brand-cyan'
                }`}>
                  {action.impact} Impact
                </span>
                <span className="text-[10px] text-slate-400 font-bold">{action.savings || action.lift || action.time}</span>
              </div>
            </div>
            <SafeIcon name="ChevronRight" className="w-4 h-4 text-slate-600 group-hover:text-brand-yellow transition-colors" />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default StrategicActions;